import React from 'react';
import 'whatwg-fetch';

export function buildRequestStatistic(dashletInfo) {
  let myDashlet = dashletInfo;

  let requestGraphQL = '';
  requestGraphQL += myDashlet.metadata.statisticSelected.apiRequest;
  requestGraphQL += '{';
  requestGraphQL += myDashlet.metadata.statisticSelected.graphQlQuery;

  requestGraphQL += '(';

  let filterKeys = Object.keys(myDashlet.metadata.filters);
  for (let [key, filter] of Object.entries(myDashlet.metadata.filters)) {
    if (filter.columnSelected) {
      if (filter.columnSelected.type === 'date') {
        requestGraphQL += filter.columnSelected.graphQlArgument + 'Operator';
        requestGraphQL += ':';
        requestGraphQL += '"' + filter.operatorSelected.label + '"';

        if (filter.operatorSelected.nbParam >= 1) {
          requestGraphQL += ',';
          requestGraphQL += filter.columnSelected.graphQlArgument + 'Start';
          requestGraphQL += ':"';
          requestGraphQL += filter.param1;
          requestGraphQL += '"';
        }
        if (filter.operatorSelected.nbParam === 2) {
          requestGraphQL += ',';
          requestGraphQL += filter.columnSelected.graphQlArgument + 'End';
          requestGraphQL += ':"';
          requestGraphQL += filter.param2;
          requestGraphQL += '"';
        }
      } else if (filter.columnSelected.type === 'numeric') {
        /*
                Number
            */
        requestGraphQL += filter.columnSelected.graphQlArgument + 'Operator';
        requestGraphQL += ':';
        requestGraphQL += '"' + filter.operatorSelected.label + '"';

        if (filter.operatorSelected.nbParam >= 1) {
          requestGraphQL += ',';
          requestGraphQL += filter.columnSelected.graphQlArgument + 'Start';
          requestGraphQL += ':';
          requestGraphQL += filter.param1;
        }
        if (filter.operatorSelected.nbParam === 2) {
          requestGraphQL += ',';
          requestGraphQL += filter.columnSelected.graphQlArgument + 'End';
          requestGraphQL += ':';
          requestGraphQL += filter.param2;
        }
      } else if (
        /*
                Text, picklist
            */
        filter.columnSelected.type === 'text' ||
        filter.columnSelected.type === 'picklist'
      ) {
        requestGraphQL += filter.columnSelected.graphQlArgument + 'Operator';
        requestGraphQL += ':';
        requestGraphQL += '"' + filter.operatorSelected.label + '"';

        requestGraphQL += ',';

        requestGraphQL += filter.columnSelected.graphQlArgument;
        requestGraphQL += ':';

        if (filter.columnSelected.type === 'picklist' && !filter.columnSelected.dataFile) {
          requestGraphQL += '[';
          for (let i = 0; i < filter.param1.length; i++) {
            requestGraphQL += filter.param1[i]['id'];
            if (i !== filter.param1.length - 1) {
              requestGraphQL += ',';
            }
          }

          requestGraphQL += ']';
        } else if (
          /*
                    This block concerns dataFiles picklists like state, priority or deal steps
                 */
          filter.columnSelected.type === 'picklist' &&
          filter.columnSelected.dataFile
        ) {
          if (filter.columnSelected.multi) {
            requestGraphQL += '[';
            for (let i = 0; i < filter.param1.length; i++) {
              requestGraphQL += filter.param1[i]['value'];
              if (i !== filter.param1.length - 1) {
                requestGraphQL += ',';
              }
            }
            requestGraphQL += ']';
          } else {
            requestGraphQL += filter.param1['value'];
          }
        } else {
          requestGraphQL += '"' + filter.param1 + '"';
        }
      } else if (filter.columnSelected.type === 'boolean') {
        requestGraphQL += filter.columnSelected.graphQlArgument;
        requestGraphQL += ':';
        requestGraphQL += filter.operatorSelected.label === 'Oui';
      }
    }

    if (key !== filterKeys[filterKeys.length - 1]) {
      requestGraphQL += ',';
    }
  }

  requestGraphQL += ')';

  requestGraphQL += '{';
  requestGraphQL += myDashlet.metadata.statisticSelected.graphQl;

  requestGraphQL += '}';

  requestGraphQL += '}';

  return requestGraphQL;
}
